import { HttpService } from "../http";

export class CategoryService extends HttpService {
  fetchCategories = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addCategory = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCategory = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteCategory = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
